import { render, staticRenderFns } from "./CreateTopic.vue?vue&type=template&id=0d820edf&scoped=true&"
import script from "./CreateTopic.vue?vue&type=script&lang=js&"
export * from "./CreateTopic.vue?vue&type=script&lang=js&"
import style0 from "./CreateTopic.vue?vue&type=style&index=0&id=0d820edf&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d820edf",
  null
  
)

export default component.exports